export default {
  bookmarks: [],
  subjects: [],
  categories: [],
  questions: [],
};
